import React from 'react';

export function BrandingText() {
  return (
    <b><span className="bf-red">b</span>ild<span className="bf-red">f</span>on</b>
  );
}
